// The TourGuide AI privacy policy, linked wherever TourGuide AI collects or
// displays a prospect's details (issue #307).
export const PRIVACY_POLICY_URL = 'https://www.thevectre.com/tourguide-ai-privacy-policy';

export const PRIVACY_POLICY_TEXT = 'Privacy Policy';
